import { DateRanges } from 'elasticsearch/constants'

export const RASA_FEED_URL = 'http://rasa.io/feed'

export const getConfiguration = (
  configurations: any,
  key: any,
  defaultValue?: any,
): string => {
  return configurations[key] ? configurations[key] : defaultValue
}

export const getEnumHash = (key: string, enumList: any): string => {
  const match = Object.keys(enumList).filter((x) => enumList[x] === key)[0]
  return match ? match : ''
}

export const cleanText = (text: string): string => {
  if (text != null) {
    return text.replace(/(^\s*)|(\s*$)/gi, '') /*exclude  start and end white-space */
    .replace(/[ ]{2,}/gi, ' ') /* 2 or more space to 1 */
    .replace(/\n /, '\n') /* newlines */
  } else {
    return text
  }
}

export const getShortText = (text: string, length: number): string => {
  if ( text == null ) {
    return ''
  } else {
    const ct = cleanText(text)
    if (ct.length < length) {
      return ct
    } else {
      const shorter = ct.substring(0, length)
      const words = shorter.split(' ')
      return words.slice(0, words.length - 1).join(' ') + '...'
    }
  }
}

const widgetsJSON = {
  components: [{
    colMd: '7',
    rows:
    [
      {
        component: 'TopTopicsComponent',
        title: '',
        props: {
          title: 'Topics',
        },
      },
      {
        component: 'Statistics',
        title: '',
      },
      {
        component: 'AnalyticsOpensClicksComponent',
        title: 'Monthly Snapshot',
        props: {
          dateRange: DateRanges.PastMonth,
          selectedInterval: 'week',
          selectedSegmentCode: '0',
          hideGrid: true,
        },
      },
    ],
  },
  {
    colMd: '5',
    rows: [
      {
        component: 'WidgetTopArticles',
        title: '',
        props: {
          height: '4350px',
          title: 'Top Articles',
      },
      },
    ],
  }],
}
export const getWidgetsList = (): Promise<any> => {
  return Promise.resolve(widgetsJSON.components)
}
